import React, { useState, useEffect, useRef } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { AiOutlineSearch } from 'react-icons/ai';
import { FaPrint } from 'react-icons/fa';

const StdAtdReport = ({ setLoading }) => {
    const [classes, setClasses] = useState([]);

    const [availableSections, setAvailableSections] = useState([]);
    const [selectedClassId, setSelectedClassId] = useState('');
    const [selectedSection, setSelectedSection] = useState('');
    const [report, setReport] = useState([]);
    const [academicYears, setAcademicYears] = useState([]);
    const [selectedAY, setSelectedAY] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];


    const fetchClasses = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-classes');
            if (response.ok) {
                const data = await response.json();
                setClasses(data);
            } else {
                console.error('Failed to fetch class');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAcademicYears = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-academic-years');
            if (response.ok) {
                const data = await response.json();
                const sortedData = data.sort((a, b) => b.id - a.id);
                setAcademicYears(sortedData);
            } else {
                console.error('Failed to fetch academic years');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Initial fetches for classes and academic years
    useEffect(() => {
        fetchClasses();
        fetchAcademicYears();
    }, []);

    useEffect(() => {
        if (selectedClassId) {
            const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
            if (selectedClass && selectedClass.sections) {
                const sectionArray = selectedClass.sections
                    .split(',')
                    .map((s) => s.trim())
                    .filter((s) => s !== '');
                setAvailableSections(sectionArray);
            } else {
                setAvailableSections([]);
            }
            setSelectedSection('');
        } else {
            setAvailableSections([]);
            setSelectedSection('');
        }
    }, [selectedClassId, classes]);


    const handleSearch = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            const currentYear = new Date().getFullYear();

            // Get class_name from classId
            const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
            const className = selectedClass ? selectedClass.class_name : '';

            // Build query params
            const params = new URLSearchParams();
            params.append('ay', selectedAY);
            params.append('month', selectedMonth);
            params.append('class_name', className);
            params.append('section', selectedSection);

            const url = `https://api.kcian.in/get-stdatd-report?${params.toString()}`;

            const response = await fetch(url);

            if (response.ok) {
                const data = await response.json();
                // console.log(data);
                setReport(data);
            } else {
                console.error('Failed to fetch students atd report');
            }
        } catch (error) {
            console.error('Error fetching students atd report:', error);
        } finally {
            setLoading(false);
        }
    };



    const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
    const className = selectedClass ? selectedClass.class_name : '';

    const printRef = useRef(); // ref for the report section


const handlePrint = () => {
  if (!printRef.current) return;

  const printContents = printRef.current.innerHTML;

  const printWindow = window.open('', '', 'height=600,width=800');
  printWindow.document.write('<html><head><title>Student Attendance Report</title>');

  printWindow.document.write('<style>');
  printWindow.document.write(`
    html, body {
      margin: 0;
      padding: 0;
    }
    table {
      border-collapse: collapse;
    }
    th, td {
      border: 1px solid #000;
      padding: 5px;
      text-align: center;
      white-space: nowrap;
    }
    th {
      background-color: #f0f0f0;
    }
    .profile-btn2 {
      display: none;
    }
    .profile-heading {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }
       @page {
      margin: 2px;
    }
  `);
  printWindow.document.write('</style>');

  printWindow.document.write('</head><body>');
  printWindow.document.write(printContents);
  printWindow.document.write('</body></html>');

  printWindow.document.close();
  printWindow.focus();

  printWindow.print();
  printWindow.close();
};

  
const getAllDatesInMonth = (monthName, year) => {
  const monthIndex = months.indexOf(monthName);
  const dates = [];
  const totalDays = new Date(year, monthIndex + 1, 0).getDate();

  for (let day = 1; day <= totalDays; day++) {
    const dayStr = day.toString().padStart(2, '0');
    const monthStr = (monthIndex + 1).toString().padStart(2, '0');
    dates.push(`${year}-${monthStr}-${dayStr}`);
  }

  return dates;
};

const allDates = selectedMonth && selectedAY
  ? getAllDatesInMonth(selectedMonth, selectedAY)
  : [];

  console.log(allDates);

    return (
        <>
            <section className='py-4'>
                <div className='px-4'>
                    <HeadingArea message1='Attendance' message2='Students Attendance Report' />

                    <form onSubmit={handleSearch} className='profile-card'>
                        <span className="profile-heading">Select Criteria</span>

                        <div className='row mt-3'>

                            <div className="col-lg-3 col-md-6 col-6 mb-4">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select AY*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedAY}
                                        onChange={(e) => setSelectedAY(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Select Academic Year --</option>
                                        {academicYears.map((ay) => (
                                            <option key={ay.year} value={ay.year}>
                                                {ay.year} --- {ay.title}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>


                            <div className="col-lg-3 col-md-6 col-6 mb-4">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select Month*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Select Month --</option>
                                        {months.map((month, idx) => (
                                            <option key={idx} value={month}>
                                                {month}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>


                            <div className="col-lg-3 col-md-6 col-6 mb-4">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select Class*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedClassId}
                                        onChange={(e) => setSelectedClassId(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Select Class --</option>
                                        {classes.map((cls) => (
                                            <option key={cls.id} value={cls.id}>
                                                {cls.class_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-6 mb-4">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select Section*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedSection}
                                        onChange={(e) => setSelectedSection(e.target.value)}
                                        disabled={availableSections.length === 0}
                                        required
                                    >
                                        <option value="">-- Select Section --</option>
                                        {availableSections.map((section, idx) => (
                                            <option key={idx} value={section}>
                                                {section}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>



                        </div>
                        {/* flex ends */}


                        <div className='text-end'>
                            <button type='submit' className='profile-btn2'>
                                <AiOutlineSearch /> Search
                            </button>
                        </div>
                    </form>
                    {/* form ends */}


                    <div className='profile-card mt-3' ref={printRef}>

                        
                        <span className="profile-heading">Student Attendance Report - {className}({selectedSection}) {selectedMonth} {selectedAY}</span>

<div className='text-end'>
                            <button type='submit' className='profile-btn2' onClick={handlePrint}>
                                <FaPrint /> Print
                            </button></div>

<p className='text-muted'>Present: P Absent: A Leave: L Holiday: H</p>
            <div className='table-responsive mb-3'>
<table className='w-100'>
<thead className='account-thead'>
  <tr>
    <th>Roll No</th>
    <th>Name</th>
    <th>Reg No</th>
    <th>P</th>
    <th>A</th>
    <th>L</th>
    <th>H</th>
    <th>%</th>
{allDates.map(date => (
  <th key={date} className='text-nowrap'>{new Date(date).getDate()}</th>
))}
    <th>Note</th>
  </tr>
</thead>

<tbody>
  {report.length === 0 ? (
    <tr className='text-center account-tr'>
      <td colSpan="100%">No Student Data found</td>
    </tr>
  ) : (() => {
    const grouped = {};

    // Group by student_id
    report.forEach(rpt => {
      const id = rpt.student_id;
      if (!grouped[id]) {
        grouped[id] = {
          student_name: rpt.student_name,
          roll_no: rpt.roll_no,
          reg_no: rpt.reg_no,
          dates: {},
          present: 0,
          absent: 0,
          leave: 0,
          holiday: 0,
          note: rpt.note,
        };
      }

      const mark = rpt.mark;

      if (mark === 'Present') grouped[id].present += 1;
      else if (mark === 'Absent') grouped[id].absent += 1;
      else if (mark === 'Leave') grouped[id].leave += 1;
      else if (mark === 'Holiday') grouped[id].holiday += 1;

      grouped[id].dates[rpt.date] = mark[0]; // Use 'P', 'A', or 'L'
    });

    return Object.entries(grouped).map(([id, data], index) => (
      <tr key={index} className='account-tr'>
        <td className='border'>{data.roll_no}</td>
        <td className='border'>{data.student_name}</td>
        <td className='border'>{data.reg_no}</td>
        <td className='border'>{data.present}</td>
        <td className='border'>{data.absent}</td>
        <td className='border'>{data.leave}</td>
        <td className='border'>{data.holiday}</td>
<td className='border'>
  {(
    ((data.present + data.holiday) / (data.present + data.holiday + data.absent + data.leave)) * 100
  ).toFixed(1)}%
</td>
{allDates.map(date => (
  <td className='border' key={date}>{data.dates[date] || ''}</td>
))}
        <td className='border'>{data.note}</td>
      </tr>
    ));
  })()}
</tbody>



</table>
</div>


                    </div>
{/* report ends */}


                </div>
            </section>
        </>
    )
}

export default StdAtdReport
